import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"];
  static values = { time: Number };

  initialize() {
    console.log("countdown controller init ...");
    setInterval(() => {
      const units = this.timeUnits();
      this.daysTarget.innerHTML = units.days.toString().padStart(2, "0");
      this.hoursTarget.innerHTML = units.hours.toString().padStart(2, "0");
      this.minutesTarget.innerHTML = units.minutes.toString().padStart(2, "0");
      this.secondsTarget.innerHTML = units.seconds.toString().padStart(2, "0");
    }, 1000);
  }

  timeUnits() {
    const current = new Date();
    let remaining = this.timeValue - current.getTime() / 1000;

    const days = Number.parseInt(remaining / (24 * 3600));
    remaining -= days * (24 * 3600);

    const hours = Number.parseInt(remaining / 3600);
    remaining -= hours * 3600;

    const minutes = Number.parseInt(remaining / 60);
    remaining -= minutes * 60;

    const seconds = Number.parseInt(remaining);

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }

  connect() {}
}
